// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatSourceSwitch-moduleswitch__rC5fk";
export { _1 as "switch" }
